module.exports = __webpack_public_path__ + "static/media/hist-monkey.8699bc74.jpg";